import React from "react";
import styled from "styled-components";
import { theme } from "../theme/config";
import { useTranslation } from "react-i18next";
import { Container, MainSection } from "../theme/shared";
import hero from "../assets/images/hero.svg";
import arrowOrange from "../assets/images/arrow-orange.svg";

const StyledSection = styled(MainSection)`
  background: ${theme.colors.green.default};
  margin-top: -50px;
`;

const Content = styled.div`
  color: ${theme.colors.white.default};
  font-family: ${theme.fonts.default};
  font-size: 1rem;
  line-height: 150%;
  padding: 30px 0 0;
  margin-bottom: 80px;
  font-weight: 200;
  @media (max-width: ${theme.breakpoints.tablet.max}) {
    margin-bottom: 40px;
  }
`;

const Header = styled.h1`
  font-family: ${theme.fonts.headers};
  font-size: 1.75rem;
  line-height: 150%;
  margin-bottom: 1.5rem;
  @media (max-width: ${theme.breakpoints.tablet.max}) {
    font-size: 1.5rem;
  }
`;

const Button = styled.a`
  border: 1px solid ${theme.colors.orange.default};
  background: ${theme.colors.orange.default};
  color: ${theme.colors.green.default};
  font-family: ${theme.fonts.headers};
  font-size: 1.563rem;
  line-height: 1;
  border-radius: 44px;
  padding: 1.875rem 2.625rem;
  display: inline-block;
  text-decoration: none;
  position: relative;
  cursor: pointer;
  transition: background-color 400ms linear;

  @media (max-width: ${theme.breakpoints.tablet.max}) {
    font-size: 0.938rem;
    padding: 0.938rem 2.5rem;
    margin-right: 1.5rem;
  }
  &:before {
    content: " ";
    background: url(${arrowOrange}) no-repeat;
    width: 8.375rem;
    height: 7.625rem;
    position: absolute;
    top: -5rem;
    right: -8.375rem;
    @media (max-width: ${theme.breakpoints.tablet.max}) {
      display: none !important;
    }
  }
`;

const HeroContainer = styled(Container)`
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: ${theme.breakpoints.tablet.max}) {
    flex-direction: column;
    align-items: start;
  }
`;

const Text = styled.div`
  @media (min-width: ${theme.breakpoints.desktop.min}) {
    width: 50%;
    padding-top: 130px;
    padding-bottom: 20px;
  }
`;

const Address = styled.div`
  color: ${theme.colors.white.default};
  font-family: ${theme.fonts.default};
  font-size: 1rem;
  line-height: 150%;
  margin-top: 40px;
  margin-bottom: 40px;
  a {
    text-decoration: none;
    color: ${theme.colors.orange.default};
    &:hover {
      text-decoration: underline;
    }
  }
`;

const Image = styled.div`
  padding-left: 45px;
  @media (max-width: ${theme.breakpoints.tablet.max}) {
    padding-left: 0;
  }
  @media (min-width: ${theme.breakpoints.desktop.min}) {
    width: 50%;
  }
  img {
    max-width: 100%;
  }
`;

function Hero() {
  const { t } = useTranslation();
  return (
    <StyledSection id={"home"}>
      <HeroContainer>
        <Text>
          <Content>
            <Header>
              &quot;Owoce do Biura&quot; dołączają do BetterWorkplace!
            </Header>
            Z radością informujemy, że marka &quot;Owoce do Biura&quot; stała
            się częścią rodziny BetterWorkplace – solidnego partnera w budowaniu
            przyjaznych miejsc pracy.
            <br />
            To połączenie oznacza jeszcze sprawniejszą logistykę, szerszą ofertę
            produktów i kompleksowe wsparcie dla firm, które dbają o dobrostan
            swoich zespołów.
            <br />
            Razem dostarczamy więcej niż owoce – tworzymy lepsze miejsca pracy.
          </Content>
          <Button href={"https://betterworkplace.pl/"}>
            {t("Przejdź do BetterWorkplace")}
          </Button>
          <Address>
            Dane kontaktowe i fakturowanie oraz dane rozliczeniowe pozostają bez
            zmian.
            <br />
            Kontakt:{" "}
            <a href="mailto:kontakt@betterworkplace.pl">
              kontakt@betterworkplace.pl
            </a>
          </Address>
        </Text>
        <Image>
          <img src={hero} alt={"owocedobiura.pl"} />
        </Image>
      </HeroContainer>
    </StyledSection>
  );
}

export default Hero;
